import React, { useState, useEffect } from 'react';
import { Save, Upload, Image as ImageIcon } from 'lucide-react';
import toast from 'react-hot-toast';
import { Card, Label, Input, Button } from '../components/ui';

export default function ConfiguracoesScreen() {
  const [config, setConfig] = useState({ 
    cnpj: '', api_user: '', api_pass: '', empresa_nome: '', empresa_logo: '' 
  });

  useEffect(() => {
    setConfig({
      cnpj: localStorage.getItem('@up2_cnpj') || '',
      api_user: localStorage.getItem('@up2_api_user') || '',
      api_pass: localStorage.getItem('@up2_api_pass') || '',
      empresa_nome: localStorage.getItem('@up2_empresa_nome') || '',
      empresa_logo: localStorage.getItem('@up2_empresa_logo') || ''
    });
  }, []);

  const salvar = () => {
    localStorage.setItem('@up2_cnpj', config.cnpj);
    localStorage.setItem('@up2_api_user', config.api_user);
    localStorage.setItem('@up2_api_pass', config.api_pass);
    localStorage.setItem('@up2_empresa_nome', config.empresa_nome);
    localStorage.setItem('@up2_empresa_logo', config.empresa_logo);
    toast.success('Configurações salvas localmente!');
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2000000) {
        toast.error('A imagem deve ter no máximo 2MB.');
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setConfig({ ...config, empresa_logo: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500 pb-10">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900">Configurações</h2>
        <p className="text-slate-500">Gerencie as credenciais, CNPJ e a identidade visual do PDF.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="text-lg font-bold text-slate-800 mb-4">Integração com API</h3>
          <div className="space-y-4">
            <div>
              <Label>CNPJ da Empresa</Label>
              <Input 
                placeholder="00.000.000/0000-00" 
                value={config.cnpj}
                onChange={e => setConfig({...config, cnpj: e.target.value})}
              />
              <p className="text-xs text-slate-500 mt-1">Usado na URL de consulta de preços.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <Label>Usuário - API</Label>
                <Input 
                  value={config.api_user}
                  onChange={e => setConfig({...config, api_user: e.target.value})}
                />
              </div>
              <div>
                <Label>Senha - API</Label>
                <Input 
                  type="password"
                  value={config.api_pass}
                  onChange={e => setConfig({...config, api_pass: e.target.value})}
                />
              </div>
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="text-lg font-bold text-slate-800 mb-4">Identidade Visual (PDF)</h3>
          <div className="space-y-4">
            <div>
              <Label>Nome da Empresa (Cabeçalho)</Label>
              <Input 
                placeholder="Ex: UP2 Soluções em TI" 
                value={config.empresa_nome}
                onChange={e => setConfig({...config, empresa_nome: e.target.value})}
              />
            </div>
            <div>
              <Label>Logotipo (Recomendado: PNG ou JPG fundo branco)</Label>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mt-2">
                {config.empresa_logo ? (
                  <img src={config.empresa_logo} alt="Logo" className="h-16 w-auto object-contain border rounded p-1" />
                ) : (
                  <div className="h-16 w-full sm:w-24 bg-slate-100 border border-dashed border-slate-300 rounded flex items-center justify-center text-slate-400">
                    <ImageIcon size={24} />
                  </div>
                )}
                <div className="flex-1 w-full">
                  <input 
                    type="file" 
                    id="logo-upload" 
                    accept="image/*" 
                    className="hidden" 
                    onChange={handleImageUpload} 
                  />
                  <label 
                    htmlFor="logo-upload" 
                    className="cursor-pointer w-full sm:w-auto inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors border border-slate-200 bg-white hover:bg-slate-100 text-slate-900 h-9 px-4"
                  >
                    <Upload size={16} className="mr-2" /> Escolher Imagem
                  </label>
                  {config.empresa_logo && (
                    <button onClick={() => setConfig({...config, empresa_logo: ''})} className="mt-2 sm:mt-0 sm:ml-3 text-xs text-red-500 hover:underline block sm:inline-block">
                      Remover
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>

      <div className="flex justify-end">
        <Button onClick={salvar} className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-700">
          <Save size={18} className="mr-2" />
          Salvar Configurações
        </Button>
      </div>
    </div>
  );
}